import { useMutation } from '@tanstack/react-query'

import { deleteScimAccessToken } from '@src/api'
import { DefaultApiDeleteScimAccessTokenRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteScimAccessToken = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiDeleteScimAccessTokenRequest) =>
      deleteScimAccessToken(axiosInstance, params),
  })
}
